import { render, staticRenderFns } from "./ExamSubmitSuccess.vue?vue&type=template&id=7e3c32be&scoped=true"
import script from "./ExamSubmitSuccess.vue?vue&type=script&lang=js"
export * from "./ExamSubmitSuccess.vue?vue&type=script&lang=js"
import style0 from "./ExamSubmitSuccess.vue?vue&type=style&index=0&id=7e3c32be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3c32be",
  null
  
)

export default component.exports